import React, { useState, useEffect } from "react";
import { Routes, Route, useNavigate, useLocation,Outlet } from "react-router-dom";
import UserGuide from "./userGuide";
import { useSelector, useDispatch } from "react-redux";
import {updateTabStates } from '../../store/actions';
const HelpPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const themeMode = useSelector((state) => state.themeMode);
  const [lastSegment, setLastSegment] = useState("");
  const dispatch = useDispatch();
  const topMenuTabs = useSelector((state) => state.topMenuTabs);



  const handleNavigate = (path) => {
    navigate(path);
  };

  return (
    <div
      className={`w-full min-h-screen ${
        themeMode === "dark" ? "bg-[#1a1a28]" : "bg-[#ffffff]"
      } py-4 sm:py-6 lg:py-8`}
    >
      {/* Theme Toggle Button for Demo */}


      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Title */}
        <h1
          className={`text-2xl sm:text-3xl lg:text-4xl font-bold text-center ${
            themeMode === "dark" ? "text-white" : "text-gray-800"
          } mb-4 sm:mb-6 lg:mb-8`}
        >
          Help & Support
        </h1>

        {/* About the Project Section */}
        <section className="mb-6 sm:mb-8 lg:mb-10">
          <h2
            className={`text-xl sm:text-2xl font-semibold ${
              themeMode === "dark" ? "text-white" : "text-gray-700"
            } mb-3 sm:mb-4`}
          >
            About the Project
          </h2>
          <p
            className={`text-sm sm:text-base leading-relaxed ${
              themeMode === "dark" ? "text-white" : "text-gray-600"
            } mb-4`}
          >
            This survey project has been created to collect and analyze the
            valuable opinions of our users. Our goal is to improve your
            experience and continuously enhance the services we offer.
          </p>
          <button
            onClick={() => handleNavigate("/help/userGuide")}
            className="w-full sm:w-auto px-4 sm:px-6 py-2 sm:py-3 bg-blue-600 text-white text-sm sm:text-base rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all duration-200"
          >
            Go to User Guide
          </button>
        </section>

        {/* How to Contribute Section */}
        <section className="mb-6 sm:mb-8 lg:mb-10">
          <h2
            className={`text-xl sm:text-2xl font-semibold ${
              themeMode === "dark" ? "text-white" : "text-gray-700"
            } mb-3 sm:mb-4`}
          >
            How Can I Contribute?
          </h2>
          <p
            className={`text-sm sm:text-base leading-relaxed ${
              themeMode === "dark" ? "text-white" : "text-gray-600"
            } mb-3 sm:mb-4`}
          >
            You can contribute to the project by filling out surveys and
            providing feedback.
          </p>
          <ul
            className={`list-disc pl-4 sm:pl-5 space-y-2 text-sm sm:text-base ${
              themeMode === "dark" ? "text-white" : "text-gray-600"
            }`}
          >
            <li className="leading-relaxed">Fill out the survey form carefully.</li>
            <li className="leading-relaxed">Share your feedback and suggestions with us.</li>
            <li className="leading-relaxed">If you encounter any issues, contact our support team.</li>
          </ul>
        </section>

        {/* FAQ Section */}
        <section className="mb-6 sm:mb-8 lg:mb-10">
          <h2
            className={`text-xl sm:text-2xl font-semibold ${
              themeMode === "dark" ? "text-white" : "text-gray-700"
            } mb-3 sm:mb-4`}
          >
            Frequently Asked Questions (FAQ)
          </h2>
          <div className="space-y-4 sm:space-y-6">
            <div className={`p-4 sm:p-5 rounded-lg border transition-colors ${
              themeMode === "dark" 
                ? "border-white/10 bg-white/5 hover:bg-white/10" 
                : "border-gray-200 bg-gray-50 hover:bg-gray-100"
            }`}>
              <h3
                className={`font-medium text-sm sm:text-base mb-2 ${
                  themeMode === "dark" ? "text-white" : "text-gray-800"
                }`}
              >
                How is my survey data protected?
              </h3>
              <p
                className={`text-sm sm:text-base leading-relaxed ${
                  themeMode === "dark" ? "text-white/80" : "text-gray-600"
                }`}
              >
                All data is protected with SSL encryption. You can review our
                privacy policy for detailed information.
              </p>
            </div>
            
            <div className={`p-4 sm:p-5 rounded-lg border transition-colors ${
              themeMode === "dark" 
                ? "border-white/10 bg-white/5 hover:bg-white/10" 
                : "border-gray-200 bg-gray-50 hover:bg-gray-100"
            }`}>
              <h3
                className={`font-medium text-sm sm:text-base mb-2 ${
                  themeMode === "dark" ? "text-white" : "text-gray-800"
                }`}
              >
                How long does it take to complete the survey?
              </h3>
              <p
                className={`text-sm sm:text-base leading-relaxed ${
                  themeMode === "dark" ? "text-white/80" : "text-gray-600"
                }`}
              >
                It takes approximately 5-10 minutes, depending on the length
                of the survey.
              </p>
            </div>
            
            <div className={`p-4 sm:p-5 rounded-lg border transition-colors ${
              themeMode === "dark" 
                ? "border-white/10 bg-white/5 hover:bg-white/10" 
                : "border-gray-200 bg-gray-50 hover:bg-gray-100"
            }`}>
              <h3
                className={`font-medium text-sm sm:text-base mb-2 ${
                  themeMode === "dark" ? "text-white" : "text-gray-800"
                }`}
              >
                How can I contact the support team?
              </h3>
              <p
                className={`text-sm sm:text-base leading-relaxed ${
                  themeMode === "dark" ? "text-white/80" : "text-gray-600"
                }`}
              >
                For support, you can email us at{" "}
                <a
                  href="mailto:esevim@ereteam.com"
                  className="text-blue-500 hover:text-blue-600 underline break-all transition-colors duration-200"
                >
                  esevim@ereteam.com
                </a>
              </p>
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className={`p-4 sm:p-6 rounded-lg border transition-colors ${
          themeMode === "dark" 
            ? "border-white/10 bg-white/5" 
            : "border-gray-200 bg-blue-50"
        }`}>
          <h2
            className={`text-xl sm:text-2xl font-semibold ${
              themeMode === "dark" ? "text-white" : "text-gray-700"
            } mb-3 sm:mb-4`}
          >
            Contact
          </h2>
          <p
            className={`text-sm sm:text-base leading-relaxed ${
              themeMode === "dark" ? "text-white/80" : "text-gray-600"
            }`}
          >
            For questions or suggestions, you can reach us via email at{" "}
            <a
              href="mailto:esevim@ereteam.com"
              className="text-blue-500 hover:text-blue-600 underline break-all transition-colors duration-200 font-medium"
            >
              esevim@ereteam.com
            </a>
          </p>
        </section>
      </div>
       <Outlet />
        {/* <Routes>
        <Route path="userGuide" element={<UserGuide />} />
      </Routes> */}
    </div>
  );
};

export default HelpPage;